import * as React from "react";
import { SVGProps, memo } from "react";

const SvgHome = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={21} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.583 16.75h3.125v-4.583c0-.177.06-.326.18-.446s.268-.18.445-.18h3.333c.177 0 .326.06.446.18s.18.269.18.446v4.583h3.124V8.625L10 4.562 4.583 8.625v8.125Zm-1.25 0V8.625a1.241 1.241 0 0 1 .5-1L9.25 3.562c.217-.166.466-.25.746-.25.28 0 .531.084.754.25l5.416 4.063a1.24 1.24 0 0 1 .5 1v8.125c0 .344-.122.638-.367.883s-.539.367-.883.367h-3.75a.605.605 0 0 1-.445-.18.605.605 0 0 1-.18-.445v-4.583H8.958v4.583c0 .177-.06.326-.18.445a.605.605 0 0 1-.445.18h-3.75c-.344 0-.638-.122-.883-.367a1.204 1.204 0 0 1-.367-.883Z"
      fill="#E98E16"
    />
  </svg>
);

const Memo = memo(SvgHome);

export default Memo;
